import React from "react";
import PaypalDetails from "./paypalDetails";
import ConnectPaypal from "./connectPaypal"
import { useSelector } from "react-redux";

const PaypalSetupWrapper = () => {
  const paypalInfo = useSelector(state => state.paypalInfo);

  const getComponent = () => {
    if(paypalInfo !== null) return <PaypalDetails />
    return <ConnectPaypal />
  }

  return (
    <div className="p-3 px-5 fw-light bank-info-container d-flex">
      <span className="fw-bold">Paypal</span>
      {getComponent()}
    </div>
  );
};

export default PaypalSetupWrapper;
